module.exports = __webpack_public_path__ + "img/capsula, tableta, gragea, comprimido, perla, pastilla, gomita.8cff6f20.png";